"use strict";

module.exports = function (h, classes, item) {
  if (classes.framework === 'bulma') {
    return item;
  }

  return h("li", [item]);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/modules/dropdown-item-wrapper.js
// module id = 1652
// module chunks = 64